import { render, staticRenderFns } from "./PreviewJobBody.vue?vue&type=template&id=5d22e630&scoped=true"
import script from "./PreviewJobBody.vue?vue&type=script&lang=ts"
export * from "./PreviewJobBody.vue?vue&type=script&lang=ts"
import style0 from "./PreviewJobBody.scss?vue&type=style&index=0&id=5d22e630&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d22e630",
  null
  
)

export default component.exports